export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8065.30d8eeb6.jpg";